import React,{ useState, useEffect, useRef, useCallback } from 'react';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import styled from '@emotion/styled';
import ReactDOM from 'react-dom';

import 'simplebar/dist/simplebar.min.css';

const Modal = ({ setModal, isOpen, children, onModalClose }) => {

  const [ container, setContainer ] = useState(null);
  const [ fade , setFade ] = useState(false);
  const [ displayed, setDisplayed ] = useState(false);

  let fadeTimer = useRef(null);

  useEffect(() => {
    if(document)
      setContainer(document.querySelector('.tl-wrapper'));
  },[]);

  const closePopup = useCallback((e) => {

    if(e)
    {
      e.preventDefault();
      e.stopPropagation();
    }
    
    setFade(false);

    setTimeout(() => {
      setModal(false);
      setDisplayed(false);
      
      if(onModalClose)
        onModalClose();
    },300);
  },[onModalClose,setModal]);

  useEffect(() => {
    if(!isOpen && !fade)
      return;

    if(isOpen && !displayed)
    {
      setDisplayed(true);
      fadeTimer.current = setTimeout(() => {
        setFade(true);
      },100);
    } else if(!isOpen && displayed) {
      closePopup();
    }
    

  }, [ isOpen, displayed, closePopup ]);




  return (<React.Fragment>
    {container && ReactDOM.createPortal(
      <ModalWrapper className={`${displayed ? 'opened' : ''} ${fade ? 'active' : ''}`}>
        <Overlay onClick={closePopup} />
        <ModalContent>
          <BtnClose href="#" onClick={closePopup} />
          <SwiperWrapper onClick={closePopup}>
            {children}
          </SwiperWrapper>
        </ModalContent>
      </ModalWrapper>, container)
    }
  </React.Fragment>);
}
 
export default Modal;


const ModalWrapper = styled.div`
  position: fixed;
  z-index: 9999;
  top:0;
  left:0;
  right:0;
  bottom:0;
  
  display:none;
  

  .swiper-container{
    overflow:visible
  }
  .swiper-wrapper{
    align-items: center;
  }
  
  .swiper-slide{
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0,0,0);
  }
  .swiper-wrapper{
    -webkit-transform-style: preserve-3d;
    @media only screen and (min-width: ${breakpoint.mdMin}) and (min-height: 1200px){
      align-items:center;
    }
    @media only screen and (max-width: ${breakpoint.smMax}) and (min-height: 650px){
      align-items:center;
    }

    @media only screen and (max-width: ${breakpoint.xsMax}) and (min-height: 450px){
      align-items:center;
    }
    
  }

  &.opened{
    display:block;
  }

  > * {
    opacity:0;
    transition: opacity .3s;
  }

  &.active > * {
    opacity:1;
  }

`

const Overlay = styled.div`
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background: rgba(28, 28, 29, 0.95);
`



const ModalContent = styled.div`
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  overflow:auto;
  line-height:100vh;
  text-align:center;

  #modal-scroll{
    height:100%;
    width:100%;

    .simplebar-track.simplebar-vertical{
      width:7px;
    }
  }

`

const SwiperWrapper = styled.div`
  position:relative;
  width:100%;
  margin:0 auto;
  display:inline-block;
  vertical-align:middle;
  overflow:hidden;
  .cardWrapper{
    padding:30px calc((100% - 928px) / 2);
  }

  @media only screen and (max-width: ${breakpoint.smMax}){

    .cardWrapper{
      padding:30px calc((100% - 608px) / 2);
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    max-width: none;
    .cardWrapper{
      padding:30px calc((100% - 270px) / 2);
    }
  }
`
const BtnClose = styled.a`
  width:64px;
  height:64px;
  position:absolute;
  top:48px;
  right:48px;
  z-index:999;

  &:before,&:after{
    content:' ';
    position:absolute;
    top:50%;
    left:50%;
    width:45px;
    height:3px;
    border-radius:2px;
    transform:translate(-50%,-50%) rotate(-45deg);
    background:#FFFFFF;
  }
  &:after{
    transform:translate(-50%,-50%) rotate(45deg);
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:48px;
    height:48px;
    top:32px;
    right:32px;
    &:before,&:after{
      width:35px;
      height:2px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:32px;
    height:32px;
    top:16px;
    right:16px;
    &:before,&:after{
      width:25px;
      height:1px;
    }
  }
`;
